import Vue from "vue";
import Vuex from "vuex";

/** Modules */
import nav from "./modules/nav";
import cursor from "./modules/cursor";
import api from "./modules/api";
import i18n from "./modules/i18n";
import navigation from "./modules/navigation";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    skipIntro: null,
    isMobile: false,
    showNav: false
  },
  mutations: {
    skipIntro(state, status) {
      state.skipIntro = status;
      sessionStorage.setItem("skipIntro", status.toString());
    },
    changeEditMode(state, status) {
      state.editMode = status;
    },
    setMobile(state, status) {
      state.isMobile = status;
    },
    setShownav(state, status) {
      state.showNav = status;
    },
  },
  getters: {
    skipIntro: (state) => {
      return state.skipIntro;
    },
    getIsMobile: (state) => {
      return state.isMobile;
    },
    getShowNav: (state) => {
      return state.showNav;
    },
  },
  actions: {},
  modules: {
    cursor,
    nav,
    api,
    i18n,
    navigation,
  },
});
